var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mealTypes.length)?_c('v-select',{attrs:{"label":_vm.$t('change_extra_meal_type'),"items":_vm.mealTypes,"item-value":"id","item-text":_vm.mealTypeLabel,"prepend-item":{name: '', value: null},"clearable":_vm.clearable,"value":_vm.$attrs.value,"disabled":_vm.disabled},on:{"change":_vm.update}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }